import React from 'react';
import { Container } from '../global';

const MarginDemo: React.FC = () => {
  return (
    <div className="space-y-12">
      {/* Header with page title */}
      <Container showMargins={true} className="pt-20 pb-8">
        <h1 className="text-3xl font-bold mb-4">Margin Visualization Demo</h1>
        <p className="text-xl">
          Purple areas show the dynamic margins. They'll change as you resize the browser.
        </p>
        <p className="bg-yellow-100 p-4 mt-4 border-l-4 border-yellow-500">
          <strong>Debug info is shown at the top of the screen</strong>, displaying viewport width, 
          current margin size, and active breakpoint.
        </p>
      </Container>
      
      {/* Content block with borders */}
      <Container showMargins={true}>
        <div className="border-2 border-blue-500 p-6 bg-blue-50">
          <h2 className="text-2xl font-bold">Content Inside Margins</h2>
          <p className="mt-2">
            This content stays within the margins. The purple overlays show where your content shouldn't go
            on mobile screens.
          </p>
        </div>
      </Container>
      
      {/* Example of a full width background with content inside margins */}
      <Container fullWidth className="bg-gray-800 py-12">
        <Container showMargins={true}>
          <div className="text-white">
            <h2 className="text-2xl font-bold">Full Width Background</h2>
            <p className="mt-2">
              The background extends full width, but content still respects the margins.
            </p>
          </div>
        </Container>
      </Container>
      
      {/* Example showing how items normally positioned */}
      <Container fullWidth className="bg-green-100 py-12">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl font-bold mb-6">Full Width Without Container</h2>
          
          {/* Add side-by-side comparison */}
          <div className="flex flex-col w-full md:flex-row md:gap-6">
            <div className="w-full md:w-1/2 p-4">
              <Container showMargins={true} className="h-full bg-white p-6 rounded shadow">
                <h3 className="text-xl font-semibold border-b pb-2 mb-4">With Container & Margins</h3>
                <p>This content respects the margin constraints and will always stay within the purple lines on mobile.</p>
              </Container>
            </div>
            
            <div className="w-full md:w-1/2 p-4">
              <div className="h-full bg-white p-6 rounded shadow">
                <h3 className="text-xl font-semibold border-b pb-2 mb-4">Without Container</h3>
                <p>This content has no margin constraints and will extend to the edge of its parent.</p>
              </div>
            </div>
          </div>
        </div>
      </Container>
      
      {/* Example with colored content to show padding is working */}
      <Container showMargins={true} className="pb-20">
        <div className="bg-purple-100 p-6 rounded-lg">
          <h2 className="text-2xl font-bold">Testing With Colored Content</h2>
          <p className="mt-4">
            This colored box helps you see exactly where the content boundaries are relative to the margins.
          </p>
          <div className="mt-6 flex flex-wrap gap-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="w-16 h-16 bg-purple-500 rounded flex items-center justify-center text-white font-bold">
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MarginDemo; 